export const base_port = ":8082";
export const base_url = "https://www.api.shefaei.com" ;
export const ws_url = "wss://www.api.shefaei.com" ;
export const api_url = base_url + "/api/v1";

let token = localStorage.getItem( "token" );

if ( token !== "" && token !== undefined && typeof token !== 'undefined' && token !== 'undefined'){
	token = JSON.parse( token );
}


export const server_file_url = base_url + "/api/v1/serveFile/" + ( token ) + "/";
